import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/userSlice"
import dateReducer from "../features/dateSlice";

export default configureStore({
    reducer: {
        user: userReducer,
        date: dateReducer,
    },
});